'use strict';

const { categories } = require('dibs-endpoints');
const {
    addHeaders,
    fetchWrapper,
    addParamsToUrl,
} = require('dibs-service-fetch-wrappers/dist/util');

/**
 * Action that makes categories service call to get the list of categories
 *  and update the store with retrieved categories
 *
 * @param {Context} ac
 * @param {Array}   keys - specific category keys to fetch from categories service
 * @param {Array}   fields - array of fields that to pass to categories endpoint
 * @param {function} done
 */
function fetchCategories(ac, { keys, fields }, done) {
    const url = addParamsToUrl(categories(), { keys, fields });

    fetchWrapper(url, addHeaders({ method: 'get' }))
        .then(response => {
            if (response.result) {
                ac.dispatch('SET_CATEGORIES', response.result);
            }
            done();
        })
        .catch(error => {
            ac.dispatch('SET_CATEGORIES_ERROR', { error });
            done();
        });
}

/**
 * Action for fetching categories needed for gallery
 *
 * @param ac
 * @param payload
 * @param done
 */
function fetchGalleryCategories(ac, payload, done) {
    ac.executeAction(
        fetchCategories,
        {
            keys: ['F', 'A'],
            fields: ['descendants'],
        },
        done
    );
}

module.exports = {
    fetchCategories,
    fetchGalleryCategories,
};



// WEBPACK FOOTER //
// ./assets/js/global/actions/categoriesActions.es.js